import { HeaderContent } from './headerContent';
import { NutritionTable } from './nutrition-table';
import { ProductListing } from './product-listing';
import { SpecialMessage } from './special-message';

export class ShopWindowManager {

    header: HeaderContent;
    productClassification: any;
    legalNotes: Array<string>;
    nutritionTable: NutritionTable;
    productListing: ProductListing;
    specialMessages: Array <SpecialMessage>;

    constructor(shopWindow : any) { 
        this.header = shopWindow.header;
        this.productClassification = shopWindow.productClassification;
        this.legalNotes = shopWindow.legalNotes;
        this.nutritionTable = shopWindow.nutritionTable;
        this.productListing = shopWindow.productListing;
        this.specialMessages = shopWindow.specialMessages;
    }
}
